export const genKey   = () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
export const safePhone = (value: string = "") => value.replace(/\D/g, "").replace(/^91/, "").slice(-10);
export const waUrl = (phone: string = "", text = "") => {
  const p = safePhone(phone);
  if (!p) return "#";
  return `https://wa.me/91${p}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};
export const mapsUrl = (address: string = "") => address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}` : "#";
export const telUrl = (phone: string = "") => {
  const p = safePhone(phone);
  return p ? `tel:+91${p}` : "#";
};
export const openExternal = (url: string) => {
  try {
    const u = new URL(url);
    if (!["https:", "tel:"].includes(u.protocol)) return;
    window.open(url, "_blank", "noopener,noreferrer");
  } catch {}
};
